/** Shared circular badge leaflet/HTML marker used for facility and address-pair icons. */

const lucideStrokeSvgHtml = (paths: readonly string[], color: string, size: number) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths
    .map((d) => `<path d="${d}"/>`)
    .join('')}</svg>`;

export const circularBadgeMarkerHtml = (paths: readonly string[], color: string) => `
  <div style="
    width: 36px;
    height: 36px;
    border-radius: 9999px;
    background: #ffffff;
    border: 2px solid ${color};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.25);
    box-sizing: border-box;
  ">
    ${lucideStrokeSvgHtml(paths, color, 18)}
  </div>
`;

export const pairedCircularBadgeMarkerHtml = (
  leftPaths: readonly string[],
  leftColor: string,
  rightPaths: readonly string[],
  rightColor: string
) => `
  <div style="display: flex; align-items: center; gap: 2px;">
    ${circularBadgeMarkerHtml(leftPaths, leftColor)}
    ${circularBadgeMarkerHtml(rightPaths, rightColor)}
  </div>
`;
